import { useLayoutEffect } from 'react';
import { useProductRegistrationContext } from '@/product-registration/context';

const useUpdateProductRegistrationWrapperClass = wrapperClass => {
  const [, { setWrapperClass }] = useProductRegistrationContext();
  useLayoutEffect(() => {
    setWrapperClass(wrapperClass);
  }, [wrapperClass]);
};

export default useUpdateProductRegistrationWrapperClass;
